import React from 'react';

const Insights = () => {
  return (
    <svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 10L6.28192 4.06C6.41111 3.91738 6.59016 3.82986 6.78205 3.81552C6.97395 3.80118 7.16401 3.86113 7.31296 3.98296L10.527 6.66136C10.6759 6.78318 10.866 6.84293 11.0577 6.82818C11.2495 6.81343 11.4282 6.72531 11.5566 6.58216L16.48 1"
        stroke="#4E40EF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4846 1H16.48V5.30488"
        stroke="#4E40EF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Insights;
